import { AxiosError, AxiosResponse } from 'axios';
import { axios, axiosMultipart, axiosUnauthorized } from 'config/axios';
import qs from 'qs';
import { FileData } from 'types/embedded/fileData';
import { User } from 'types/embedded/user';

export const getUserInfo = async (): Promise<User> => {
  return axios
    .get('profile/me')
    .then((response: AxiosResponse) => ({
      ...response.data,
      corporateEmail: response.data.corporate_email,
    }))
    .catch((error: AxiosError) => Promise.reject(error.message));
};

export const deleteRecord = async (id: string): Promise<AxiosResponse> => {
  return axiosUnauthorized
    .delete(id)
    .then((response: AxiosResponse) => response)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

type GenerateAliasResponse = { data: { alias: string } };
export const generateAlias = async (name: string): Promise<GenerateAliasResponse> => {
  return axios
    .get('/utils/alias?originalText=' + name)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

type GenerateNameResponse = { data: { name: string } };
export const generateName = async (
  entity: string,
  nameParams: Record<string, any>,
): Promise<GenerateNameResponse> => {
  const queryParams = qs.stringify(
    {
      ...nameParams,
    },
    { arrayFormat: 'indices', encode: true },
  );

  return axios
    .get(`/utils/${entity}/name?${queryParams}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const getReportExport = async (
  filters?: Record<string, any>,
  selectedFields?: string[],
): Promise<AxiosResponse> => {
  const params = qs.stringify(
    {
      fields: selectedFields,
      ...filters,
    },
    { arrayFormat: 'indices', encode: true },
  );

  return axios
    .get(`report_export?${params}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const getFilesList = async (entityName: string, entityId?: number): Promise<FileData[]> => {
  return axios
    .get('upload_files', {
      params: {
        entityName,
        entityId,
      },
      headers: {
        Accept: 'application/ld+json',
      },
    })
    .then((response: AxiosResponse) => response.data['hydra:member'])
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const sendFile = async (file: FormData): Promise<AxiosResponse> => {
  return axiosMultipart
    .post('upload_files', file)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const getCounter = async (resource: string): Promise<{ count: number }> => {
  return axios
    .get(resource)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const updateUserLanguage = async (language: 'ru' | 'en'): Promise<User> => {
  return axios
    .patch('profile/language', { language })
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.message));
};
